<template>
    <div id="inventory-items-container">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{$t('DrugInventoryItemsList.Title')}}</h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3">                      
                        <MdButton
                            v-bind:Label="$t('DrugInventoryItemsList.AddInventoryItem')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddInventoryItem"
                            v-bind:Name="'btn_add_allergy'">
                        </MdButton>
                    </div>

                    <div  class="col-sm-12 col-md-9 mb-4">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"   
                                    @keyup.enter="SearchInventoryItem"                            
                                >
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton 
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchInventoryItem">
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                <div class="row">
                    <div class="col-md-12">
                        <MdTable 
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            v-bind:VisibleEditIcon="true"
                            v-bind:VisibleDeleteIcon="true"
                            :editIconEvent="EditInventoryItem"
                            :deleteIconEvent="RemoveInventoryItem"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction">
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InventoryItemService from '@/services/inventoryitem.service'
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'InventoryItemList',
    mixins: [DBFunctions, ShowMessage],

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                btnvisible:false,
                ItemsList:[],
                favButtonAtion: false
            }, 
            parameter: {
                SearchCriteria: '',
                PageNumber : 0,
                PageSize: 0 ,
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            fields: [
                { key: 'itemcode', sortable: true, label: this.$t('Shared.Code'), class: 'text-rigth' }, 
                { key: 'description', sortable: true, label: this.$t('Shared.Description'), class: 'text-rigth'}, 
                { key: 'dispensingQty', sortable: true, label: this.$t('DrugInventoryItem.DispensingQty'), class: 'text-rigth'},     
                { key: 'dispensingCapacity', sortable: true, label: this.$t('DrugInventoryItem.DispensingCapacity'), class: 'text-rigth' },  
                { key: 'dispensinguom', sortable: true, label: this.$t('DrugInventoryItem.DispensingUOM'), class: 'text-rigth' }, 
                { key: 'purchaseuom', sortable: true, label: this.$t('DrugInventoryItem.PurchaseUOM'), class: 'text-rigth' }, 
                { key: 'unitineach', sortable: true, label: this.$t('DrugInventoryItem.PurchaseQuantity'), class: 'text-rigth' },
                { key: 'dispensingunitcost', sortable: true, label: this.$t('DrugInventoryItem.UnitCost'), class: 'text-rigth' },
                { key: 'dispensingunitprice', sortable: true, label: this.$t('DrugInventoryItem.UnitPrice'), class: 'text-rigth' },
                { key: 'cost', sortable: true, label: this.$t('DrugInventoryItem.PurchasePrice'), class: 'text-rigth' },
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            isReadOnly: false,
            ShowMessageIsEmpty:false,
        }
    },

    methods: {
        AddInventoryItem() {
            this.$router.push({ name: "drugInventoryItemsAdd" })
        },

        SearchInventoryItem() {
            this.items = [];
            this.totalRows = 0;
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            InventoryItemService
                .getAll(this.parameter)
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.items = response.data;

                        let headerString = response.headers["x-pagination"];
                        const Header = JSON.parse(headerString);
                        this.totalRows = Header.TotalCount;
                    }

                    this.ShowMessageIsEmpty = this.items.length === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        EditInventoryItem(row) {
            this.$router.push({ name: "drugInventoryItemsEdit", params: {recId: row.itemcode} });
        },

        RemoveInventoryItem(row) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$t('DrugInventoryItem.DeleteTitle'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
                    id:'modal_delete_allergy'
				})
                .then(value => {
                    if(value){
                        InventoryItemService.delete(row.itemcode)
                            .then(() => {
                                this.currentPage = 1;
                                this.SearchInventoryItem();
                            })
                            .catch((error) => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                })
        },

        onRowSelected(/*items*/) {    
            //this.selected = items;
        },

        pageChanged(page) {            
            this.currentPage = page;
            this.SearchInventoryItem();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.SearchInventoryItem();
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
    },

    mounted() {
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;    
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
        case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }  

        this.$nextTick(() => {
            this.SearchInventoryItem();
        });
    }
}
</script>